export const categories = [
  {
    id: 1,
    title: "Educación",
    icon: require("../Assets/Imagenes/educacion.png"),
    color: "#F1D00A",
  },
  {
    id: 2,
    title: "Entretenimiento",
    icon: require("../Assets/Imagenes/entretenimiento.png"),
    color: "#FF7800",
  },
  {
    id: 3,
    title: "Alimentación",
    icon: require("../Assets/Imagenes/food.png"),
    color: "#AA14F0",
  },
  {
    id: 4,
    title: "Salud",
    icon: require("../Assets/Imagenes/health.png"),
    color: "#39A2DB",
  },
  {
    id: 5,
    title: "Compras",
    icon: require("../Assets/Imagenes/shopping.png"),
    color: "#21209C",
  },
];
